'use client';

import { FC, useState } from 'react';
import { useTranslations } from 'next-intl';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Lock } from 'lucide-react';
import { Spinner } from 'react-bootstrap';
import InputField from './InputField';
import PrimaryButton from './PrimaryButton';
import AuthFooter from './AuthFooter';
import shellStyles from './AuthShell.module.scss';
import styles from './ResetPasswordScreen.module.scss';
interface ResetPasswordScreenProps {
  initialEmail?: string;
  onSubmit: (email: string) => void | Promise<void>;
  termLink?: string;
  privacyPolicyLink?: string;
}
const ResetPasswordScreen: FC<ResetPasswordScreenProps> = ({
  initialEmail,
  onSubmit,
  termLink,
  privacyPolicyLink
}) => {
  const t = useTranslations();
  const [isLoading, setIsLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const schema = yup.object().shape({
    email: yup.string().email(t('workspace-details.form.email-error')).max(100, t('workspace-details.form.email-error')).required(t('auth.error'))
  });
  const {
    register,
    handleSubmit,
    trigger,
    formState: {
      errors
    }
  } = useForm<{
    email: string;
  }>({
    resolver: yupResolver(schema),
    defaultValues: {
      email: initialEmail ?? ''
    }
  });
  const submit = handleSubmit(async data => {
    setIsLoading(true);
    try {
      await onSubmit(data.email);
      setSubmitted(true);
    } finally {
      setIsLoading(false);
    }
  });
  return <>
            <div className={shellStyles.iconBubble}>
                <span className={shellStyles.iconBubbleInner}>
                    <Lock size={32} strokeWidth={1.75} data-sentry-element="Lock" data-sentry-source-file="ResetPasswordScreen.tsx" />
                </span>
            </div>

            <h2 className={shellStyles.heading}>
                {t('auth.resetPassword.title')}
            </h2>
            <p className={`${shellStyles.subtitle} ${styles.subtitle}`}>
                {t('auth.resetPassword.subtitle')}
            </p>

            {submitted ? <div className={styles.success}>
                    {t('auth.resetPassword.success')}
                </div> : <form className={styles.form} onSubmit={submit} noValidate>
                    <InputField type="email" autoComplete="email" placeholder={t('auth.resetPassword.email')} error={errors.email?.message} {...register('email', {
        onBlur: () => trigger('email')
      })} />

                    <PrimaryButton type="submit" disabled={isLoading}>
                        {isLoading ? <Spinner animation="border" size="sm" /> : t('auth.resetPassword.submit')}
                    </PrimaryButton>
                </form>}

            <AuthFooter termLink={termLink} privacyPolicyLink={privacyPolicyLink} data-sentry-element="AuthFooter" data-sentry-source-file="ResetPasswordScreen.tsx" />
        </>;
};
export default ResetPasswordScreen;